export const rutaImg = process.env.REACT_APP_BASE_URL + process.env.REACT_APP_API + process.env.REACT_APP_IMAGENES

export const useValidarImagen = (img) => img ? rutaImg + img : 'https://static.vecteezy.com/system/resources/thumbnails/008/847/320/small/isolated-white-t-shirt-front-free-png.png'

export const useValidarImagenCarousel = (img) => img ? rutaImg + img : 'https://mdbootstrap.com/img/Photos/Slides/img%20(45).webp'
